import type { ActionCardProps } from '@/lib/types/ui.types';
import { cn } from '@/lib/utils';

export function ActionCard({
  title,
  subtext,
  'icon': Icon,
  hasBadge = false,
  badgeColor = 'purple',
  onClickAction,
  className,
  'data-testid': dataTestId,
}: ActionCardProps) {
  const badgeColorClass = `bg-${badgeColor}-400`;
  const ariaLabel =
    typeof title === 'string' ? title : subtext || 'Action card';
  return (
    <button
      type="button"
      onClick={onClickAction}
      data-testid={dataTestId}
      className={cn(
        'w-full flex items-center justify-between rounded-2xl bg-slate-600 px-5 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-300',
        className
      )}
      aria-label={ariaLabel}
    >
      <div className="flex items-center gap-3">
        {hasBadge && (
          <span
            aria-hidden="true"
            className={cn('h-3 w-3 rounded-full', badgeColorClass)}
          />
        )}
        <span
          className="text-large text-slate-200 font-semibold"
          style={{ fontSize: 'clamp(14px, 4vw, 18px)' }}
        >
          {title}
        </span>
      </div>
      {subtext ? (
        <div className="flex items-center gap-2 text-slate-400">
          <span
            className="text-body"
            style={{ fontSize: 'clamp(12px, 3vw, 14px)' }}
          >
            {subtext}
          </span>
          <Icon size={18} weight="bold" />
        </div>
      ) : (
        <Icon className="text-slate-400 text-body" size={18} weight="bold" />
      )}
    </button>
  );
}
